import React from "react";
import { BuildingOffice2Icon, MapPinIcon } from "@heroicons/react/24/outline";

const TABS = [
    {
        key: "organizational_units",
        label: "Unità organizzative",
        Icon: BuildingOffice2Icon,
    },
    {
        key: "working_areas",
        label: "Aree di lavoro",
        Icon: MapPinIcon,
    },
];

export default function StatisticsViewControls({ mode, onModeChange, className = "", canViewWorkingAreas = false, canManageWorkingAreas = false }) {
    const showWorkingAreas = canViewWorkingAreas || canManageWorkingAreas;
    const visibleTabs = showWorkingAreas ? TABS : TABS.filter(({ key }) => key !== "working_areas");
    
    return (
        <div className={`flex flex-col gap-4 rounded-xl border border-gray-300 bg-white p-4 sm:p-5 lg:flex-row lg:items-center lg:justify-between ${className}`}>
            <div className="min-w-0">
                <h3 className="text-base font-semibold uppercase text-indigo-800">
                    {showWorkingAreas
                        ? "Seleziona visualizzazione statistiche"
                        : "Statistiche"
                    }
                </h3>

                <p className="mt-1 text-xs text-gray-500">
                    {showWorkingAreas
                        ? "Scegli se visualizzare le statistiche per unità organizzative o per aree di lavoro"
                        : "Visualizza le statistiche delle unità organizzative"
                    }
                </p>
            </div>

            <div className={`grid w-full grid-cols-1 overflow-hidden rounded-lg shadow-sm ${showWorkingAreas ? "sm:grid-cols-2 lg:w-auto lg:min-w-[440px]" : "lg:w-auto lg:min-w-[220px]"}`}>
                {visibleTabs.map(({ key, label, Icon }, index) => {
                    const active = mode === key;

                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => onModeChange?.(key)}
                            className={`relative flex min-w-0 items-center justify-center gap-2 border px-4 py-3 text-xs font-semibold transition sm:text-sm
                                ${
                                    showWorkingAreas
                                        ? index === 0
                                            ? "sm:rounded-l-lg"
                                            : "sm:rounded-r-lg"
                                        : "rounded-lg"
                                }
                                ${
                                    active
                                        ? "z-10 border-indigo-300 bg-indigo-100 text-indigo-800"
                                        : "border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100"
                                }
                            `}
                        >
                            <Icon className="h-5 w-5 shrink-0" />

                            <span className="truncate">
                                {label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}